import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton } from '@23/react'

import { useConfirmationModal } from '../../../global/hooks/useConfirmationModal'

interface DeleteChatMessageConfirmationProps {
  onConfirm: () => void
  onCancel: () => void
}

const DeleteChatMessageConfirmation = ({
  onConfirm,
  onCancel,
}: DeleteChatMessageConfirmationProps) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <TtButton
        slot="footer"
        color="danger"
        pill
        onClick={() => {
          onConfirm()
          setIsLoading(true)
        }}
        loading={isLoading}
      >
        <FormattedMessage defaultMessage="Delete" />
      </TtButton>
      <TtButton
        slot="footer"
        color="secondary"
        variant="outline"
        pill
        disabled={isLoading}
        onClick={onCancel}
      >
        <FormattedMessage defaultMessage="Cancel" />
      </TtButton>
    </>
  )
}

const useDeleteChatMessageConfirmation = () => {
  return useConfirmationModal(DeleteChatMessageConfirmation, {
    title: 'Are you sure you want to delete this chat message?',
  })
}

export { useDeleteChatMessageConfirmation }
